export const routes = {
  root: "/",
  rooms: "/rooms",
  site: "/site",
  contact: "/contact",
};
